import axios from 'axios';

import { IAffConferencierConference } from '@/shared/model/aff-conferencier-conference.model';

const baseApiUrl = 'api/aff-conferencier-conferences';

export default class AffConferencierConferenceService {
  public find(id: number): Promise<IAffConferencierConference> {
    return new Promise<IAffConferencierConference>((resolve, reject) => {
      axios
        .get(`${baseApiUrl}/${id}`)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public retrieve(): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(baseApiUrl)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public delete(id: number): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .delete(`${baseApiUrl}/${id}`)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public create(entity: IAffConferencierConference): Promise<IAffConferencierConference> {
    return new Promise<IAffConferencierConference>((resolve, reject) => {
      axios
        .post(`${baseApiUrl}`, entity)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public update(entity: IAffConferencierConference): Promise<IAffConferencierConference> {
    return new Promise<IAffConferencierConference>((resolve, reject) => {
      axios
        .put(`${baseApiUrl}`, entity)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }
}
